import React from "react";
import { removeHttps } from "../../../utils/Helperfunctions";
import { SocialImageUrl } from "./../../../utils/BaseUrl";

export default function SocialProfile(props) {
  if (Object.keys(props.social).length < 1) return <></>;
  return (
    <>
      {props?.social?.indiefolio_url && props?.social?.indiefolio_url !== "" ? (
        <a
          className="basic_profile"
          target="_blank"
          rel="noopener noreferrer"
          href={"http://" + removeHttps(props?.social?.indiefolio_url)}
        >
          <img
            src={SocialImageUrl + props?.social?.indiefolio_image}
            //src="https://i.postimg.cc/HWf6XhSG/indiefolio.png"
            alt="social-profile"
            className="img-fluid mx-2"
          />
        </a>
      ) : (
        <></>
      )}
      {props?.social?.behance_url && props?.social?.behance_url !== "" ? (
        <a
          className="basic_profile"
          target="_blank"
          rel="noopener noreferrer"
          href={"http://" + removeHttps(props?.social?.behance_url)}
        >
          <img
            src={SocialImageUrl + props?.social?.behance_image}
            //src="https://i.postimg.cc/8PMtHm37/behance.png"
            alt="social-profile"
            className="img-fluid mx-2"
          />
        </a>
      ) : (
        <></>
      )}
      {props?.social?.dribbble_url && props?.social?.dribbble_url !== "" ? (
        <a
          className="basic_profile"
          target="_blank"
          rel="noopener noreferrer"
          href={"http://" + removeHttps(props?.social?.dribbble_url)}
        >
          <img
            src={SocialImageUrl + props?.social?.dribbble_image}
            //src="https://i.postimg.cc/cHvc8Rw4/dribbble.png"
            alt="social-profile"
            className="img-fluid mx-2"
          />
        </a>
      ) : (
        <></>
      )}
      {props?.social?.instagram_url && props?.social?.instagram_url !== "" ? (
        <a
          className="basic_profile"
          target="_blank"
          rel="noopener noreferrer"
          href={"http://" + removeHttps(props?.social?.instagram_url)}
        >
          <img
            src={SocialImageUrl + props?.social?.instagram_image}
            //src="https://i.postimg.cc/sfZcjJ3T/instagram.png"
            alt="social-profile"
            className="img-fluid mx-2"
          />
        </a>
      ) : (
        <></>
      )}
      {props?.social?.vimeo_url && props?.social?.vimeo_url !== "" ? (
        <a
          className="basic_profile"
          target="_blank"
          rel="noopener noreferrer"
          href={"http://" + removeHttps(props?.social?.vimeo_url)}
        >
          <img
            src={SocialImageUrl + props?.social?.vimeo_image}
            //src="https://i.postimg.cc/Ghxvt7Vx/vimeo.png"
            alt="social-profile"
            className="img-fluid mx-2"
          />
        </a>
      ) : (
        <></>
      )}
      {props?.social?.personal_url && props?.social?.personal_url !== "" ? (
        <a
          className="basic_profile"
          target="_blank"
          rel="noopener noreferrer"
          href={"http://" + removeHttps(props?.social?.personal_url)}
        >
          <img
            src={SocialImageUrl + props?.social?.personal_image}
            //src="https://i.postimg.cc/1z2q2LVs/youtube.png"
            alt="social-profile"
            className="img-fluid mx-2"
          />
        </a>
      ) : (
        <></>
      )}
      {props?.social?.custom_url && props?.social?.custom_url !== "" ? (
        <a
          className="basic_profile"
          target="_blank"
          rel="noopener noreferrer"
          href={"http://" + removeHttps(props?.social?.custom_url)}
        >
          <img
            src={SocialImageUrl + props?.social?.custom_image}
            //src="https://i.postimg.cc/c408p7Cg/custom-link.png"
            alt="social-profile"
            className="img-fluid mx-2"
          />
        </a>
      ) : (
        <></>
      )}
      {props?.social?.custom_url1 && props?.social?.custom_url1 !== "" ? (
        <a
          className="basic_profile"
          target="_blank"
          rel="noopener noreferrer"
          href={"http://" + removeHttps(props?.social?.custom_url1)}
        >
          <img
            src={SocialImageUrl + props?.social?.custom_image}
            //src="https://i.postimg.cc/c408p7Cg/custom-link.png"
            alt="social-profile"
            className="img-fluid mx-2"
          />
        </a>
      ) : (
        <></>
      )}
      {props?.social?.custom_url2 && props?.social?.custom_url2 !== "" ? (
        <a
          className="basic_profile"
          target="_blank"
          rel="noopener noreferrer"
          href={"http://" + removeHttps(props?.social?.custom_url2)}
        >
          <img
            src={SocialImageUrl + props?.social?.custom_image}
            //src="https://i.postimg.cc/c408p7Cg/custom-link.png"
            alt="social-profile"
            className="img-fluid mx-2"
          />
        </a>
      ) : (
        <></>
      )}
    </>
  );
}
